var n = Object.defineProperty;
var a = (t, e, u) => e in t ? n(t, e, { enumerable: !0, configurable: !0, writable: !0, value: u }) : t[e] = u;
var q = (t, e, u) => (a(t, typeof e != "symbol" ? e + "" : e, u), u), _ = (t, e, u) => {
  if (!e.has(t))
    throw TypeError("Cannot " + u);
};
var s = (t, e, u) => (_(t, e, "read from private field"), u ? u.call(t) : e.get(t)), p = (t, e, u) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, u);
}, c = (t, e, u, l) => (_(t, e, "write to private field"), l ? l.call(t, u) : e.set(t, u), u);
var i, r, h;
class o {
  constructor() {
    q(this, "_queue", []);
    p(this, i, []);
    p(this, r, []);
    p(this, h, void 0);
  }
  get queue() {
    return this._queue;
  }
  // Добавляет элемент в конец
  push(e) {
    this._queue.push(e), s(this, r).forEach((u) => {
      u();
    });
  }
  // Удаляет последний элемент и возвращает его
  pop() {
    return this._queue.pop();
  }
  // Добавляет элемент в начало
  unshift() {
    this._queue.unshift();
  }
  // Удаляет первый элемент и возвращает его
  shift() {
    return this._queue.shift();
  }
  getAll() {
    return this._queue;
  }
  getAllWithClear() {
    return this._queue.splice(0);
  }
  splice(e, u) {
    return this._queue.splice(e, u);
  }
  clear() {
    this._queue = [];
  }
  addSubscribe(e) {
    s(this, r).push(e);
  }
  registerExporter(e) {
    e.initQueue(this), s(this, i).push(e);
  }
  setMeter(e) {
    c(this, h, e), s(this, i).forEach((u) => {
      u.setMeter(s(this, h));
    });
  }
}
i = new WeakMap(), r = new WeakMap(), h = new WeakMap();
export {
  o as default
};
